const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  apps: [],
  //tags: []
}
///
const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState,
  reducers: {
    myApplicationList: (state, action) => {
      state.apps = action.payload;
    }
  }
});


////
/* const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState,
  reducers: {
    myApplicationList: (state, action) => {
      state.apps = action.payload;
    },
    setTags: (state, action) => {
      state.tags = action.payload;
    }
  }
}); */

//export const { myApplicationList, setTags } = applicationSlice.actions;
export const { myApplicationList} = applicationSlice.actions;
export default applicationSlice.reducer;